import { Typography } from "@packages/ds";
import styled from "styled-components";

import { ButtonWrapper as DsButtonWrapper, Link } from "ds/Button";
import InputDs from "ds/Input";

export const ButtonWrapper = styled(DsButtonWrapper)`
  margin-top: 40px;
`;

export const Layout = styled.div`
  display: flex;
  flex-shrink: 0;
  margin: 0;
`;

export const Text = styled.p`
  margin: 0;
  font-size: 15px;
`;

export const TextName = styled.p`
  margin: 0;
  margin-right: 10px;
`;

export const LearnMoreLink = styled(Link)`
  padding-left: 3px;
  padding-bottom: 3px;
  font-size: 15px;
`;

export const LearnMoreContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 32px;
  font-size: 15px;
`;

export const AddDomainFormLayout = styled.form`
  box-sizing: border-box;
  width: 100%;
  background: var(--section-snow-background-color, var(--snow));
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  button,
  a {
    width: max-content;
    margin: 0;
  }
`;

export const Header = styled.h2`
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  margin: 0;
`;

export const SubHeader = styled(Typography.BodyText)``;

export const ReplacementDomainContainer = styled.div`
  display: flex;
`;

export const AttachedContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const SelectWrapper = styled.div`
  max-width: 264px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const Input = styled(InputDs)`
  margin-bottom: 16px;
  & > input {
    width: 264px;
    @media (max-width: 768px) {
      width: 100%;
    }
  }
`;

export const Label = styled(Typography.Label)`
  margin-right: 12px;
`;
